import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class ActivateAccountRequest {
  @jsonMember(String)
  public token!: string;

  public constructor(token: string) {
    this.token = token;
  }
}
